import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=c744d6dc&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=c744d6dc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c744d6dc",
  null
  
)

export default component.exports